import { Badge } from "@/components/badge";
import { cn } from "@/lib/utils";
import type { ObservationTag } from "../../../../shared/observation-types";

export const TAG_LABELS: Record<ObservationTag, string> = {
  win: "Win",
  obstacle: "Obstacle",
  risk: "Risk",
  na: "N/A",
};

// Single source of per-tag color, aligned with the functional-form vocabulary:
// Win → forest, Obstacle → sunlight, Risk → error, N/A → neutral sand. `fill` is
// the badge background+text; `border` is the accent the form's tag picker uses for
// its selected state. Both the badge here and the picker in observation-form.tsx
// derive from this map so a tag's color is defined once. These tags are a sanctioned
// colored vocabulary per ADR-0013 (they carry valence, not pure category) — keep all
// values tokenized.
export const TAG_COLOR: Record<ObservationTag, { fill: string; border: string }> = {
  win: { fill: "bg-success-soft text-success", border: "border-success" },
  obstacle: {
    fill: "bg-sunlight-100 text-sunlight-500",
    border: "border-sunlight-500",
  },
  risk: { fill: "bg-danger-soft text-destructive", border: "border-destructive" },
  na: { fill: "bg-muted text-muted-strong", border: "border-sand-400" },
};

interface ObservationTagBadgeProps {
  tag: ObservationTag;
  className?: string;
}

export function ObservationTagBadge({ tag, className }: ObservationTagBadgeProps) {
  return (
    <Badge
      variant="category"
      className={cn(TAG_COLOR[tag].fill, "border-transparent", className)}
    >
      {TAG_LABELS[tag]}
    </Badge>
  );
}
